import { Component } from '@angular/core';
import { Utilityservice } from '../../utility/utilityservice.service';
import { StateService } from './state.service';
import Swal from 'sweetalert2';
import { StatemodalComponent } from '../../directives/statemodal/statemodal.component';
import { LazyLoadEvent, MenuItem, SortEvent } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { GlobalMessage } from '../../utility/modals';
import { ExceldownloadComponent } from 'src/app/views/directives/exceldownload/exceldownload.component';


@Component({
  selector: 'app-state',
  templateUrl: './state.component.html',
  styleUrls: ['./state.component.css']
})
export class StateComponent {
  cols: any[];
  rowsize: number = 10;
  options = [{ label: 10, value: 10 }];
  _selectedColumns: any[];
  customsort: boolean = true;
  showcount: number = 0;
  hidecount: number = 0;
  items: MenuItem[] = [];
  statelistarray: Array<any> = [];
  paginatorArray = [];
  commonScrollHeight = '';
  statelist: any;
  excel_paragraph = '';
  message:GlobalMessage=new GlobalMessage()
  ref: DynamicDialogRef | undefined;
  searchTerm: string = ''; 

  constructor(
    private utilityservice: Utilityservice, private StateService: StateService, public dialogService: DialogService,
  ) {
    this.excel_paragraph = this.message.downloadexcel_text;
  }
  handlePageChange(event: any) {
    this.rowsize = event.rows
  }
  dynamiccols() {
    this.cols = [
      { field: 'stateid', header: 'State Id', type: 'text', sort: false, width: '2px !important', isChecked: true, class: 'headerid' },
      { field: "statename", header: "State Name", type: 'text', sort: false, width: '20px', isChecked: true, class: 'otherheader' },
      { field: "country", header: "Country", type: 'text', sort: false, width: '20px', isChecked: true, class: 'otherheader' },
      { field: "createdon", header: "Created On", type: 'text', sort: false, width: '20px', isChecked: true, class: 'otherheader' },
      { field: "activeflag", header: "Status", type: 'text', sort: false, width: '20px', isChecked: true, class: 'otherheader' }

    ]
    this._selectedColumns = this.cols;
    this.utilityservice.headerObservable.next(this.cols);
    this.showcount = 4;
    this.hidecount = 2;
  }

  ngOnInit() {
    this.commonScrollHeight = this.utilityservice.scrollHeight
    this.getAllData();
    // this.items = this.dashService.getComplianceMenuList();
    this.dynamiccols();
  }

  getAllData(event?: LazyLoadEvent) {

    this.StateService.getData().subscribe((data) => {
      this.statelist = data;
      this.statelistarray = this.statelist;
      this.options = this.utilityservice.getOptionDropdown(data.length);
      this.paginatorArray = this.options.map(e => e.value);
    }, error => {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error.error.error,
        footer: "error status is :" + ' ' + error.status
      });
    });
  }

  customSort(event: SortEvent) {

    event.data.sort((data1, data2) => {
      let value1 = data1[event.field];
      let value2 = data2[event.field];
      let result = 0;

      const isDate = (date) => !isNaN(Date.parse(date));

      if (value1 == null && value2 != null) result = -1;
      else if (value1 != null && value2 == null) result = 1;
      else if (value1 == null && value2 == null) result = 0;
      else if (typeof value1 === 'string' && typeof value2 === 'string') {
        if (isDate(value1) && isDate(value2)) {
          const date1 = new Date(value1);
          const date2 = new Date(value2);
          result = date1 < date2 ? -1 : date1 > date2 ? 1 : 0;
        } else {
          result = value1.localeCompare(value2);
        }
      } else {
        result = value1 < value2 ? -1 : value1 > value2 ? 1 : 0;
      }
      return event.order * result;
    });

  }
  show(title, data) { 
    let details = {};
    if (title === 'Modify State') {
      this.StateService.getModify(data.stateid).subscribe((res: any) => {
        if (res.length === 0) {
          Swal.fire({
            icon: 'error',
            title: 'Data Error',
            text: 'Data is null',
          });
        } else {
          details = res;
          this.ref = this.dialogService.open(StatemodalComponent, {
            header: title,
            width: '40vw',
            height: '25vw',
            data: { title: title, datas: details },
            contentStyle: { overflow: 'auto' },
            baseZIndex: 100
          });
          this.ref.onClose.subscribe(() => {
            this.getAllData();
          });
        }
      })
    } else {
      details = {};
      this.ref = this.dialogService.open(StatemodalComponent, {
        header: title,
        width: '40vw',
        height: '20vw',
        data: { title: title, datas: details },
        contentStyle: { overflow: 'auto', },
        baseZIndex: 100
      });
      this.ref.onClose.subscribe((res) => {
        this.getAllData();
      });
    }
  }

  exceDownloadModel() {
    let payload = {}
    //const width = this.utilityserv.isMobile() ? '90vw' : 'auto';
    this.ref = this.dialogService.open(ExceldownloadComponent, {
      header: "Excel Download",
      width: '55vw',
      height: '11vw',
      data: {
        excelname: "State.xlsx", downloadapi: 'common/state/getstateexcel',
        method: 'get', message: this.excel_paragraph, payload: payload
      },
      contentStyle: { overflow: 'hidden' },
      maximizable: false,
      position: 'center'

    })
  }

  cleanRegExp(str: string): string {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  highlight(input: string, searchstring: string | number): string {
    if (!searchstring) return input;
    const safeText = String(input ?? '');
    const safeSearch = this.cleanRegExp(String(searchstring));
    const re = new RegExp(safeSearch, 'gi');
    return safeText.replace(re, match => `<span class="highlightsearch">${match}</span>`);
  }


}
